/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('email', require('./components/Email.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
/*
window.onload = function () {
    var app = document.getElementById('app');
    if (app) {
    const app = new Vue({
        el: '#app',
    });
    }
};
*/

// Sweet ALert 2 Import
const Swal = require('sweetalert2');
window.Swal = Swal;

// Swiper Import
window.Swiper = require('swiper/bundle').default;
import 'swiper/swiper-bundle.min.css';


/* Swiper Home and Menu Item */
var swiper = new Swiper('.swiper-container', {
    //freeMode: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 0,
    scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
    },
});
/* On click Flip Card Home Swioe menu item */
$(".card").on('click',function(){
    $(this).toggleClass("is-flipped");
});

/* On click Flip Card Home Swioe menu item */
$(".card__face--front").on('click',function(){
    let item_id = $(this).data('item_id');
    axios.get('/menu/item/add/'+item_id)
    .then( (res) => {
    }).catch(error => Exception.handle(error));
});

/* On click subscribe button check and send parameters to be subscribed*/
$("#subscribe-email-btn").on('click',function(){
    let newsletter_first_name = $("#newsletter_first_name").val();
    let newsletter_last_name = $("#newsletter_last_name").val();
    let newsletter_email = $("#newsletter_email").val();
    let checked = $("#email-agree").is(":checked");

    if(newsletter_first_name.length <= 0) {
        $("#first_name_required").text('First Name is required!');
    }else{
        $("#first_name_required").text('');
    }
    if(newsletter_last_name.length <= 0) {
        $("#last_name_required").text('Last Name is required!');
    }else{
        $("#last_name_required").text('');
    }
    if(emailIsValid(newsletter_email) == false) {
        $("#email_required").text('Email is required!');
    }else{
        $("#email_required").text('');
    }
    if(checked == false) {
        $("#email-agree_required").text('Checkbox is required!');
    }else{
        $("#email-agree_required").text('');
    }
    if(checked == true){
        subscribeEmail(newsletter_first_name, newsletter_last_name, newsletter_email);
    }
});

// Subscribe email to Newsletter, if email is not subscribed
function subscribeEmail(first_name, last_name, email){
    axios.post('/email/subscribe', { first_name:first_name, last_name:last_name, email:email })
    .then( (res) => {
        if(res.data == 'success'){
            Swal.fire({
                icon: 'success',
                title: 'Email subscribed with success!',
                showConfirmButton: false,
                timer: 3500
            });
        }else if(res.data == 'user_exists'){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Email already registered!',
            });
        }
        //Clean Form
        $("#newsletter_first_name").val('')
        $("#newsletter_last_name").val('');
        $("#newsletter_email").val('');
        $("#email-agree").prop("checked", false);

    }).catch(error => Exception.handle(error));
}

// Validate Email format
function emailIsValid (email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
